import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Grid from "@mui/material/Grid";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { validMobileNumber } from "../../custom-hooks/validRegex";
import {
  getEmiAndProcessingFee,
  getLoanTenureService,
} from "../../services/applicationFormService";
import {
  equifaxSoftPull,
  loanEligibilityCheck,
  userConsent,
  verifyMobile,
  verifyPANOnGrid,
  saveDetails,
  verifyPin,
  getPincdoeDetails,
  resendVerificationEmail,
} from "../../services/authenticationService";
import ErrorModal from "../common/ErrorModal";
import TermsAndCondition from "../common/TermAndCondition";
import CAlert from "../utils/CAlert";
import CInput from "../utils/CInput";
import CSelectBox from "../utils/CSelectBox";
import AddressModal from "./AddressModal";
import EligibilityModal from "./EligibilityModal";
import OTPModal from "./OTPModal";
import { setAppLoader } from "../../actions/setAppLoader";
import success from "../../assets/images/Vector.svg";
import VerifiedIcon from "@mui/icons-material/Verified";
import PanTool from "@mui/icons-material/PanTool";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import EvaluationDeclaration from "./EvaluationDeclaration";
import Privacy from "../common/Privacy";
import useMediaQuery from "@mui/material/useMediaQuery";
import { is } from "date-fns/locale";
import { use } from "react";
import { set } from "date-fns";
import CAutoComplete from "../utils/CAutoComplete";

export default function SelfEvaluationVerificationV1(props) {
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = React.useState(null);
  const [phoneError, setPhoneError] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");
  const [otp, setOtp] = React.useState([]);
  const [mobileNumberVerified, setMobileNumberVerified] = React.useState(false);
  const [details, setDetails] = React.useState();
  const [pinCode, setPinCode] = React.useState();
  const [pinCodeVerified, setpinCodeVerified] = React.useState(false);
  const [panNumber, setPanNumber] = React.useState();
  const [email, setEmail] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [city, setCity] = React.useState("");
  const [cityList, setCityList] = React.useState([]);
  const [userState, setUserState] = React.useState("");
  const [userStreet, setUserStreet] = React.useState("");
  const [panNumberVerified, setPanNumberVerified] = React.useState(false);
  const [loanTenure, setLoanTenure] = React.useState("");
  const [userAddress, setUserAddress] = React.useState("");
  const [emi, setEMI] = React.useState(0);
  const [applicantType, setApplicantType] = React.useState("");
  const [openOtp, setOpenOtp] = React.useState(false);
  const [openAddr, setOpenAddr] = React.useState(false);
  const [locationError, setLocationError] = React.useState(false);
  const [isAcceptedMandatoryConsent, setIsAcceptedMandatoryConsent] =
    React.useState(false);
  const [isAcceptedOptionalConsent, setIsAcceptedOptionalConsent] =
    React.useState(false);
  const [userId, setUserId] = React.useState();

  const [openTC, setOpenTC] = React.useState(false);
  const [openPrivacy, setOpenPrivacy] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [isExistingUser, setIsExistionUser] = React.useState(false);
  const [invalidPanCount, setInvalidPanCount] = React.useState(0);
  const [technicalError, setTechnicalError] = React.useState(false);
  // const [openDecl, setOpenDecl] = React.useState(true)

  const dispatch = useDispatch();

  async function onSendOTPClick(mobileNumber) {
    setMobileNumber(mobileNumber);
    dispatch(setAppLoader(true));
    if (!validMobileNumber.test(mobileNumber)) {
      setPhoneError(true);
      setErrorMsg(
        "Enter mobile number linked with PAN and bank account without 0 or country code"
      );
      dispatch(setAppLoader(false));
    } else {
      await verifyMobile(mobileNumber)
        .then((data) => {
          if (data.status === 200 || data.status === 201) {
            setDetails(data?.data?.details);
            setOpenOtp(true);
            setPhoneError(false);
            const mobileData = {
              details: data?.data?.details,
              mobile: mobileNumber,
            };
            localStorage.setItem("mobileData", JSON.stringify(mobileData));
          } else {
            setPhoneError(true);
            setErrorMsg(data?.data?.message);
          }
          dispatch(setAppLoader(false));
        })
        .catch((error) => {
          console.log("error", error);
          dispatch(setAppLoader(false));
        });
    }
  }

  async function onPinVerifyClick(e) {
    setPinCode(e);
    if (!e || e.length < 6) {
      setpinCodeVerified(false);
      return;
    }
    dispatch(setAppLoader(true));
    fetchPincodeDetails(e, "");

    dispatch(setAppLoader(false));
  }

  function fetchPincodeDetails(e, selectedCity) {
    if (!e || e.length < 6) {
      return;
    }
    getPincdoeDetails(e).then((data) => {
      console.log("pincode details", data);
      if (data.response != null && data.response.length) {
        console.log("pincode details 1", data);
        const cityList = [];
        const districtSet = new Set();

        data?.response?.forEach((element) => {
          if (!districtSet.has(element.district.toLowerCase())) {
            districtSet.add(element.district.toLowerCase());
            cityList.push({
              name: element.district,
              value: element.district.toLowerCase(),
              state: element.state,
            });
          }
        });
        if(cityList.includes(selectedCity)){
          setCity(selectedCity);
        } else {
          setCity("");
        }
        
        setCityList(Array.from(cityList));
        setUserState(cityList?.length ? cityList[0].state : "");
        setpinCodeVerified(true);
      } else if (data.success === false) {
        console.log("pincode details 2", data);
        setpinCodeVerified(false);
      } else {
        console.log("pincode details 3", data);
        setpinCodeVerified(false);
        if(selectedCity === "") {
          setLocationError(true);
        }
        setCity("");
        setCityList([]);
        setUserState("");
      }
    });
  }

  const onApplicantTypeChange = (event) => {
    console.log("onApplicantTypeChange", event.target.value);
    setApplicantType(event.target.value);
  };

  async function onPanVerifyClick(e) {
    e.preventDefault();
    if (!panNumber || panNumber.length < 10) {
      setError(true);
      setErrorMsg("Please Enter Valid PAN Number");
      return;
    }
    dispatch(setAppLoader(true));
    setCity("");
    setCityList([]);
    setUserState("");
    setUserStreet("");
    setUserAddress("");
    setPinCode("");
    const obj = {
      pan: panNumber,
      userId: userId,
    };

    await verifyPANOnGrid(obj).then(async (apiData) => {
      console.log("verifyPANOnGrid>>>", apiData);
      const data = apiData?.data;
      if (
        data?.response?.panStatus === "SUCCESS" &&
        (data?.response?.dedupeStatus === "SUCCESS" ||
          data?.response?.dedupeStatus === "SKIPPED")
      ) {
        setError(false);
        setErrorMsg(null);
        setIsExistionUser(false);
        console.log(data?.data);
        setInvalidPanCount(0);
        setUserAddress(
          `${data?.response?.panData?.address_data?.line_1 ?? ""} ${
            data?.response?.panData?.address_data?.line_2 ?? ""
          }`
        );
        setUserStreet(data?.response?.panData?.address_data?.street ?? "");
        const cityList = [
          {
            name: data?.response?.panData?.address_data?.city,
            value: data?.response?.panData?.address_data?.city?.toLowerCase(),
          },
        ];
        setCityList(cityList);
        setCity(data?.response?.panData?.address_data?.city?.toLowerCase());
        setUserState(data?.response?.panData?.address_data?.state);
        setPinCode(data?.response?.panData?.address_data?.pincode);
        setGender(data?.response?.panData?.gender?.toUpperCase());
        fetchPincodeDetails(
          data?.response?.panData?.address_data?.pincode,
          data?.response?.panData?.address_data?.city?.toLowerCase()
        );
        setPanNumberVerified(true);
      } else if (data?.response?.dedupeStatus === "FAILURE") {
        setIsExistionUser(true);
        setErrorMsg("Existing Customer. Kindly Login!");
        setPanNumberVerified(false);
      } else {
        console.log(invalidPanCount);
        setError(true);
        setInvalidPanCount(invalidPanCount + 1);
      }
    });
    dispatch(setAppLoader(false));
  }

  function openModel() {
    setOpenTC(true);
  }

  function openPrivacyModel() {
    setOpenPrivacy(true);
  }

  const [isEmailValid, setIsEmailValid] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleEmailChange = (e) => {
    setEmail(e);
    setIsEmailValid(emailRegex.test(e));
  };

  async function saveDetailsAndContinue(e) {
    e.preventDefault();
    dispatch(setAppLoader(true));
    if (!pinCodeVerified) {
      await onPinVerifyClick(pinCode);
      if (!pinCodeVerified) {
        return;
      }
    }
    const consent = ["MANDATORY"];
    if (isAcceptedOptionalConsent) {
      consent.push("OPTIONAL");
    }
    const obj = {
      pan: panNumber,
      email: email,
      gender: gender,
      userId: userId,
      applicantType: applicantType === "student" ? "STUDENT" : "PARENT",
      consent: consent,
      userAddress: {
        line_1: userAddress,
        line_2: "",
        line_3: "",
        street: userStreet,
        city: city,
        state: userState,
        pincode: pinCode,
      },
    };
    console.log(obj);
    await saveDetails(obj).then((data) => {
      console.log(data?.data);
    });
    dispatch(setAppLoader(false));
    setEmailSent(true);
  }
  const isMobile = useMediaQuery("(max-width:600px)");

  const [resending, setResending] = React.useState(false);

  async function handleResend() {
    setResending(true);
    await resendVerificationEmail();
    setResending(false);
  }

  return (
    <>
      <Dialog open={emailSent} maxWidth="sm" fullWidth>
  <DialogTitle
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      px: 3,
      pt: 3,
      pb: 1,
      fontSize: "1.1rem",
      fontWeight: 600,
    }}
  >
    
    Email Verification Required
  </DialogTitle>

  <DialogContent sx={{ px: 3, py: 2 }}>
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ fontSize: "0.9rem", lineHeight: 1.7 }}
    >
      Please check your inbox for an email from <strong>Flyhi</strong> and
      click the verification link.
    </Typography>

    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ mt: 2, fontSize: "0.9rem", lineHeight: 1.7 }}
    >
      Verifying your email allows us to securely send loan documents and
      application updates. You can continue with your application while the
      verification is pending.
    </Typography>
  </DialogContent>

  <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
    <Button
      variant="outlined"
      color="neutral"
      disabled={resending}
      onClick={handleResend}
    >
      {resending ? "Sending..." : "Resend Email"}
    </Button>

    <Button
      variant="contained"
      color="error"
      onClick={() =>
        navigate("/userDashboard", {
          state: {
            tabValue: 2,
            stepperCount: 2,
            userDetailId: null,
          },
        })
      }
    >
      OK
    </Button>
  </DialogActions>
</Dialog>
      <form
        onSubmit={(e) => saveDetailsAndContinue(e)}
        className="applicationFormContainer"
      >
      {error ? (
        <CAlert open={error} message={errorMsg} severity="error" />
      ) : null}
      {errorMsg === "Data Saved Successfully" ? (
        <CAlert open={true} message={errorMsg} severity="success" />
      ) : null}
      <Typography
        color="textColor"
        variant="subtitle1"
        sx={{ textAlign: "left", fontWeight: "bold" }}
      >
        Welcome to Flyhi Finance!
      </Typography>

      <Typography color="textColor" variant="body2" sx={{ textAlign: "left" }}>
        Lets quickly check your loan eligibility.
      </Typography>

      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            onChange={onApplicantTypeChange}
            name="radio-buttons-group"
          >
            <Typography
              color="textColor"
              variant="inputLabel"
              sx={{ fontWeight: "bold", textAlign: "left" }}
            >
              Applicant Type
            </Typography>
            <FormControlLabel
              value="student"
              control={<Radio />}
              label={
                <Typography color="textColor" variant="inputLabel">
                  Student
                </Typography>
              }
            />
            <FormControlLabel
              value="parent"
              control={<Radio />}
              label={
                <Typography color="textColor" variant="inputLabel">
                  Parent\Blood Relative of Student
                </Typography>
              }
            />
          </RadioGroup>
        </Grid>
        <Grid item sm={6}>
          <Box className="form" sx={{ mt: 1 }}>
            <CInput
              type="number"
              helperText={errorMsg}
              isError={phoneError ? true : false}
              maxLength={10}
              autoFocus={true}
              name="phone"
              label="Mobile Number*"
              value={mobileNumber}
              onChange={onSendOTPClick}
              disabled={mobileNumberVerified}
            />
          </Box>
        </Grid>
        <Grid item sm={1}>
          <div
            style={{
              padding: "45px 0px 0px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {mobileNumberVerified && (
              <React.Fragment>
                <VerifiedIcon
                  style={{ color: "green", fontSize: "28px", marginTop: "5px" }}
                />
              </React.Fragment>
            )}
          </div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box className="form" sx={{ mt: 1 }}>
            <CInput
              type="text"
              helperText="Invalid PAN, please try again"
              isError={error ? true : false}
              maxLength={10}
              name="phone"
              value={panNumber}
              onChange={(e) => setPanNumber(e.toUpperCase())}
              label="PAN*"
              disabled={panNumberVerified}
              subtitle="Enter PAN number and click verify to initiate PAN verification."
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              padding: isMobile ? "0px 0px 0px" : "90px 0px 0px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Button
              type="button"
              sx={{ fontStyle: "Lato" }}
              color="neutral"
              disabled={!panNumber || panNumberVerified}
              variant="outlined"
              onClick={(e) => onPanVerifyClick(e)}
            >
              Verify PAN Number
            </Button>
          </Box>
        </Grid>
        {panNumberVerified && (
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                mt: 1,
                alignItems: "center",
              }}
            >
              <VerifiedIcon
                style={{ color: "green", fontSize: "22px", marginTop: "5px" }}
              />
              <Typography
                color="textColorR"
                variant="subtitle1"
                sx={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  fontFamily: "lato",
                  marginLeft: "10px",
                }}
              >
                PAN Verified!
              </Typography>
            </Box>
          </Grid>
        )}
        {isExistingUser && (
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                mt: 1,
                alignItems: "center",
              }}
            >
              <PanTool
                style={{ color: "red", fontSize: "22px", marginTop: "5px" }}
              />
              <Typography
                color="textColorR"
                variant="subtitle1"
                sx={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  fontFamily: "lato",
                  marginLeft: "10px",
                }}
              >
                Existing Customer. Kindly Login!
              </Typography>
            </Box>
          </Grid>
        )}

        <Grid item xs={12} sm={6}>
          <Box className="form" sx={{ mt: 1 }}>
            <CInput
              type="text"
              helperText="Invalid Email, please enter correct email"
              isError={!isEmailValid && email}
              autoFocus={true}
              name="email"
              value={email}
              onChange={(e) => handleEmailChange(e)}
              label="Email*"
              subtitle="We will send a verification link to this email."
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              padding: isMobile ? "0px 0px 0px" : "5px 0px 0px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <CSelectBox
              onChange={(e) => {
                setGender(e);
              }}
              optionList={[
                { name: "Male", value: "MALE" },
                { name: "Female", value: "FEMALE" },
              ]}
              defaultValue={gender}
              name="gender"
              label="Gender*"
              subtitle="We will use this information to personalize your experience." 
            />
          </Box>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Box className="form" sx={{ mt: 1 }}>
            <CInput
              type="text"
              placeholder="Street address"
              isError={error ? true : false}
              name="address"
              value={userAddress}
              onChange={(e) => {
                setUserAddress(e);
              }}
              label="Address*"
              subtitle="Kindly validate if below record matches your current residential address. (Edit if needed)"
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Box className="form" sx={{ mt: 1 }}>
            <CInput
              type="text"
              placeholder="Landmark"
              isError={error ? true : false}
              name="landmark"
              value={userStreet}
              onChange={(e) => {
                setUserStreet(e);
              }}
              label=""
            />
          </Box>
        </Grid>
        <Grid item xs={4} sm={4}>
          <Box className="form" sx={{ mt: 1 }}>
            <CInput
              type="number"
              maxLength={6}
              name="pin"
              label=""
              placeholder="Pincode"
              value={pinCode}
              onChange={onPinVerifyClick}
              disabled={!mobileNumberVerified}
            />
          </Box>
        </Grid>
        <Grid item xs={4} sm={4}>
          <Box className="form" sx={{ mt: 1 }}>
            <CSelectBox
              onChange={(e) => {
                setCity(e);
              }}
              optionList={cityList}
              defaultValue={city}
              name="city"
              label=""
              disable={!pinCodeVerified}
            />
          </Box>
        </Grid>
        <Grid item xs={4} sm={4}>
          <Box className="form" sx={{ mt: 1 }}>
            <CInput
              type="text"
              placeholder="State"
              isError={error ? true : false}
              name="state"
              value={userState}
              onChange={(e) => {
                setUserState(e);
              }}
              label=""
              disabled={true}
            />
          </Box>
        </Grid>
        {pinCode && !pinCodeVerified && (
          <Grid item>
            <Typography variant="body2" color="textColorR" sx={{ mt: 1 }}>
              Pincode is not serviceable. Please enter a valid pincode.
            </Typography>
          </Grid>
        )}

        {pinCode && pinCodeVerified && (!city || !userState) && (
          <Grid item>
            <Typography variant="body2" color="textColorR" sx={{ mt: 1 }}>
              Please select correct city & state for your address.
            </Typography>
          </Grid>
        )}

        <Grid item sx={{ textAlign: "left", marginTop: "20px" }} xs={12}>
          <div style={{ display: "flex", alignItems: "flex-start" }}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    style={{ color: "#D32F2F" }}
                    checked={isAcceptedMandatoryConsent}
                    onChange={() =>
                      setIsAcceptedMandatoryConsent(!isAcceptedMandatoryConsent)
                    }
                    name="gilad"
                  />
                }
              />
            </FormGroup>
            <div style={{ fontSize: "16px" }}>
              <span style={{ fontWeight: "500" }}>(MANDATORY)</span>
              <div style={{ marginTop: "2px" }}>
                I/We hereby agree and acknowledge that:
              </div>
              <div style={{ paddingLeft: "7px" }}>
                <div>I/ We are above 18 years of age.</div>
                <div>I/ We are the Citizen/s and Resident/s of India.</div>
                <div>
                  I/ We can understand, read and write in the English language.
                </div>
                <div>
                  I/ We have read and understood the terms and conditions
                </div>
                <div>
                  <span
                    onClick={openModel}
                    style={{
                      cursor: "pointer",
                      color: "#D32F2F",
                      borderBottom: "1px solid #D32F2F",
                    }}
                  >
                    Terms And Conditions
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Grid>

        <Grid item sx={{ textAlign: "left" }} xs={12}>
          <div style={{ display: "flex", alignItems: "flex-start" }}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    style={{ color: "#D32F2F" }}
                    checked={isAcceptedOptionalConsent}
                    onChange={() =>
                      setIsAcceptedOptionalConsent(!isAcceptedOptionalConsent)
                    }
                    name="gilad"
                  />
                }
              />
            </FormGroup>
            <div style={{ fontSize: "16px" }}>
              <span style={{ fontWeight: "500" }}>(OPTIONAL)</span>
              <div style={{ marginTop: "2px" }}>
                I/We hereby agree and acknowledge that Flyhi or its partners can
                contact me for suggesting additional products & services.
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
      <div
        style={{
          padding: "20px 0px 0px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Button
          sx={{ fontStyle: "Lato" }}
          color="neutral"
          variant="outlined"
          onClick={() => navigate(-1)}
          style={{ marginRight: "10px" }}
        >
          Back
        </Button>
        <Button
          type="submit"
          sx={{ fontStyle: "Lato" }}
          color="neutral"
          variant="contained"
          disabled={!panNumberVerified || !isAcceptedMandatoryConsent || !city || !isEmailValid || !gender || !userAddress}
        >
          Save & Continue
        </Button>
      </div>

      {openTC && <TermsAndCondition open={openTC} setOpen={setOpenTC} />}
      {openPrivacy && <Privacy open={openPrivacy} setOpen={setOpenPrivacy} />}
      {openOtp && (
        <OTPModal
          mobileNumber={mobileNumber}
          details={details}
          otp={otp}
          openOtp={openOtp}
          setOpenOtp={setOpenOtp}
          setOtp={setOtp}
          setMobileNumberVerified={setMobileNumberVerified}
          setUserId={setUserId}
        />
      )}
      {openAddr && (
        <AddressModal
          mobileNumber={mobileNumber}
          details={details}
          otp={otp}
          openOtp={openOtp}
          setOpenOtp={setOpenOtp}
          setOtp={setOtp}
          setMobileNumberVerified={setMobileNumberVerified}
        />
      )}
      {locationError && (
        <ErrorModal open={locationError} setOpen={setLocationError} />
      )}
      {technicalError && (
        <ErrorModal
          open={technicalError}
          setOpen={setTechnicalError}
          isTechnicalError={true}
        />
      )}
      </form>
    </>
  );
}
